/* eslint-disable @typescript-eslint/no-explicit-any */
import {ENDPOINT, METHOD} from '@/constants';
import {DTO} from '../base/dto';

export class PermissionsPartnerDTO extends DTO {
  public url = ENDPOINT.PERMISSIONS_PARTNER;
  public method = METHOD.GET;
  public body: undefined;
  public query: undefined;
  public param: undefined;
  constructor() {
    super();
  }
}
